<script setup lang="ts">
  import ErrorIcon from '@/shared/assets/icons/ErrorIcon.svg';
  import { IconImage } from '@/shared/ui';
</script>

<template>
  <div class="flex flex-1 flex-col items-center justify-center gap-2 text-center">
    <span class="text-[var(--theme-secondary-ink)]">
      <IconImage :src="ErrorIcon" alt="Erro"/>
    </span>
    <div class="space-y-1">
      <p class="text-xl font-semibold text-gray-07">Nenhuma regra criada</p>
      <p class="mx-auto max-w-[290px] text-sm leading-5 text-gray-07">
        Selecione um campo de Dropdown, Checkbox ou Seleção Radial para adicionar regra
      </p>
    </div>
  </div>
</template>
